export const RANGER_CONNECT_FETCH = 'ranger/CONNECT_FETCH';
export const RANGER_CONNECT_DATA = 'ranger/CONNECT_DATA';
export const RANGER_CONNECT_ERROR = 'ranger/CONNECT_ERROR';
export const RANGER_DISCONNECT_FETCH = 'ranger/DISCONNECT_FETCH';
export const RANGER_DISCONNECT_DATA = 'ranger/DISCONNECT_DATA';
export const RANGER_DIRECT_WRITE = 'ranger/DIRECT_WRITE';
export const RANGER_SUBSCRIPTIONS_DATA = 'ranger/SUBSCRIPTIONS_DATA';
export const RANGER_USER_ORDER_UPDATE = 'ranger/USER_ORDER_UPDATE';
export const STOP_RECEIVE_SYMBOL_DATA = 'STOP_RECEIVE_SYMBOL_DATA';
